export const formatAmount = (value, decimals = 2) => {
  if (value === null || value === undefined) return "";
  return Number(value).toLocaleString("en-PH", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
};